<template>
  <Notifications />

  <div class="tw-flex tw-min-h-screen tw-flex-col tw-overflow-hidden">
    <Header :version="'1.16.22'" />

    <main
      class="tw-flex-1 tw-transition-[padding] tw-duration-300 tw-ease-in-out"
      :class="[emptyStateClass, headerPinnedClass]"
    >
      <div v-if="showEmptyState" class="tw-text-center">
        <Heading level="h1" class="tw-text-white/68">
          Click on the plus button in the upper menu for selecting the stations.
        </Heading>
      </div>

      <StationGrid v-else class="tw-m-2 lg:tw-m-5" />
    </main>

    <Logo class="tw-fixed tw-bottom-5 tw-right-5 tw-z-[-1] tw-hidden tw-w-28 lg:tw-block" />

    <VpnModal v-model="vpnModalOpen" />
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { computed, onMounted, onUnmounted, ref, watchEffect } from 'vue';

import { Heading, Logo } from '@slideslive/fuse-kit/vue';

import Header from '@/components/Header.vue';
import Notifications from '@/components/Notifications.vue';
import StationGrid from '@/components/StationGrid.vue';
import VpnModal from '@/components/VpnModal.vue';
import useStateNotifications from '@/composables/state_notifications';
import { useStationsFilterParam } from '@/composables/use_stations_filter_param';
import useSettingsStore from '@/stores/settings';
import useStationsStore from '@/stores/stations';

import useVpnStore from './stores/vpn';

const vpnStore = useVpnStore();
const { refresh: refreshVpn } = vpnStore;
const { connected: vpnConnected } = storeToRefs(vpnStore);

const stationsStore = useStationsStore();
const { selectedStationsList, selectedHosts } = storeToRefs(stationsStore);
const { refreshAll: refreshAllStations } = stationsStore;

useStationsFilterParam(selectedHosts);
useStateNotifications();

const settingsStore = useSettingsStore();
const { headerPinned } = storeToRefs(settingsStore);

const vpnModalOpen = ref(false);

watchEffect(() => {
  if (vpnConnected.value !== undefined) {
    vpnModalOpen.value = !vpnConnected.value;
  }
});

let refreshInterval = null;

onMounted(async () => {
  refreshVpn();
  refreshAllStations();

  refreshInterval = setInterval(() => {
    if (document.visibilityState === 'visible') {
      refreshAllStations({ silent: true });
    }
  }, 5000);
});

onUnmounted(() => {
  clearInterval(refreshInterval);
});

const showEmptyState = computed(() => selectedStationsList.value.length === 0);
const emptyStateClass = computed(() =>
  showEmptyState.value ? 'tw-flex tw-flex-1 tw-items-center tw-justify-center' : '',
);
const headerPinnedClass = computed(() => (headerPinned.value ? 'tw-pt-20' : 'tw-pt-0'));
</script>
